export default __webpack_public_path__ + "static/N0304-657c2fc187eb4e54a0d70ee82787b828.png";